import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {ProjectService} from '../../shared/services/project/project.service';
import {StatesService} from '../../shared/services/state/states.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ProjectSubscriptionService} from '../../shared/services/project-subscription/project-subscription.service';
import {ToastrService} from 'ngx-toastr';
import {SenceiveSubscriptionComponent} from './senceive-subscription/senceive-subscription.component';
import {Project} from '../../shared/classes/project/project';
import {CsvSftpSubscriptionComponent} from './csv-sftp-subscription/csv-sftp-subscription.component';
import {NewsteoSubscriptionComponent} from './newsteo-subscription/newsteo-subscription.component';
import {EventdynSubscriptionComponent} from './eventdyn-subscription/eventdyn-subscription.component';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';
import {ProjectMeasureService} from '../../shared/services/project-measure/project-measure.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractMatTable} from '../../shared/classes/mat-table/abstract-mat-table';
import {IconService} from '../../shared/services/icon/icon.service';
import {CrudConstants} from '../../shared/constants/crud.constants';
import CRUD_MODE = CrudConstants.CRUD_MODE;

@Component({
  selector: 'app-projects-subscriptions',
  templateUrl: './projects-subscriptions.component.html',
  styleUrls: ['./projects-subscriptions.component.css']
})
export class ProjectsSubscriptionsComponent extends AbstractMatTable implements OnInit, OnDestroy {

  readonly CRUD_MODE = CRUD_MODE;
  public levelSubscription: Subscription;
  public reloadProjectList: Subscription;
  public activeProject: boolean = true;
  public showSpinnerDelete: boolean;
  public subscriptionTypes: any[];
  public subscriptionTypeSelected = 1;

  constructor(private projectsService: ProjectService,
              public statesService: StatesService,
              private translate: TranslateService,
              private matDialog: MatDialog,
              private projectSubscriptionService: ProjectSubscriptionService,
              private toastr: ToastrService,
              private authenticationService: AuthenticationService,
              private projectMeasureService: ProjectMeasureService,
              private route: ActivatedRoute,
              private router: Router,
              public iconService: IconService) {
    super();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.displayedColumns = ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'senceive_id', 'senceive_action'];
    this.subscriptionTypes = this.route.snapshot.data['subscriptionTypes'];
    const subscriptionTypeUrl = this.route.snapshot.paramMap.get('subscriptionType');
    this.filterListByModuleType((this.subscriptionTypes.find((s) => s.keyUrl === subscriptionTypeUrl) || {value: 1}).value);
    this.levelSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getProjects()
      );
    this.reloadProjectList = this.statesService.reloadListProject
      .subscribe(() => this.getProjects()
      );
    this.getProjects();
  }

  ngOnDestroy() {
    this.levelSubscription.unsubscribe();
    this.reloadProjectList.unsubscribe();
  }

  reLoadList() {
    this.activeProject = !this.activeProject;
    this.statesService.reloadListProject.next();

  }

  filterListByModuleType(value: number) {
    this.subscriptionTypeSelected = value;
    switch (value) {
      case 1:
        this.displayedColumns = ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'senceive_id', 'senceive_action'];
        break;
      case 2:
        this.displayedColumns = ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'csv_subscription_id', 'csv_subscription_action'];
        break;
      case 3:
        this.displayedColumns = ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'newsteo_id', 'newsteo_action'];
        break;
      case 4:
        this.displayedColumns = ['id', 'code', 'name', 'address', 'start_date', 'end_date', 'eventdyn_id', 'eventdyn_action'];
        break;
      case 5:
        this.displayedColumns = ['id', 'level', 'code', 'name', 'address', 'subscription_maths_start_date', 'subscription_maths_end_date',
          'corr_therm_id', 'corr_therm_action'];
        break;
    }
    this.router.navigate(['projects-specials-behaviors', this.subscriptionTypes.find((s) => this.subscriptionTypeSelected === s.value).keyUrl], {replaceUrl: true});
  }

  getActiveTextForSlider() {
    let value: string = '';
    this.translate.get(this.activeProject ? 'PROJECT_ACTIVE' : 'PROJECT_INACTIVE').subscribe((text: string) => {
      value = text;
    });
    return value;
  }

  openProjectSubscriptionModal(project: Project, senceiveSubscriptionId: number = null) {
    const data = {
      project,
      senceiveSubscriptionId
    };
    this.matDialog.open(SenceiveSubscriptionComponent, {
      height: 'auto',
      width: 'auto',
      data
    });
  }

  openCsvSubscriptionModal(project: Project, csvSubscriptionId: number = null) {
    const data = {
      project,
      csvSubscriptionId
    };
    this.matDialog.open(CsvSftpSubscriptionComponent, {
      height: 'auto',
      width: 'auto',
      data
    });
  }

  openNewsteoSubscriptionModal(project: Project, newsteoSubscriptionId: number = null) {
    const data = {
      project,
      newsteoSubscriptionId
    };
    this.matDialog.open(NewsteoSubscriptionComponent, {
      height: 'auto',
      width: 'auto',
      data
    });
  }

  openEventdynSubscriptionModal(project: Project) {
    const data = {
      project,
    };
    this.matDialog.open(EventdynSubscriptionComponent, {
      height: 'auto',
      width: 'auto',
      data
    });
  }

  deleteNewsteoSubscription(subscriptionId: number) {
    this.showSpinnerDelete = true;
    this.projectSubscriptionService.deleteNewsteoSubscription(subscriptionId).subscribe(
      (data: any) => {
        this.statesService.reloadListProject.next();
        this.toastr.warning(this.translate.instant('SUBSCRIPTION_DELETED'), this.translate.instant('SUCCESS'));
        this.showSpinnerDelete = false;
      },
      error => {
        this.showSpinnerDelete = false;
      });
  }

  deleteSenceiveSubscription(subscriptionId: number) {
    this.showSpinnerDelete = true;
    this.projectSubscriptionService.deleteSenceiveSubscription(subscriptionId).subscribe(
      (data: any) => {
        this.statesService.reloadListProject.next();
        this.toastr.warning(this.translate.instant('SUBSCRIPTION_DELETED'), this.translate.instant('SUCCESS'));
        this.showSpinnerDelete = false;
      },
      error => {
        this.showSpinnerDelete = false;
      });
  }

  deleteCsvSubscription(subscriptionId: number) {
    this.showSpinnerDelete = true;
    this.projectSubscriptionService.deleteCsvSubscription(subscriptionId).subscribe(
      (data: any) => {
        this.statesService.reloadListProject.next();
        this.toastr.warning(this.translate.instant('SUBSCRIPTION_DELETED'), this.translate.instant('SUCCESS'));
        this.showSpinnerDelete = false;
      },
      error => {
        this.showSpinnerDelete = false;
      });
  }

  deleteEventdynSubscription(subscriptionId) {
    this.showSpinnerDelete = true;
    this.projectSubscriptionService.deleteEventdynSubscription(subscriptionId).subscribe(
      (data: any) => {
        this.statesService.reloadListProject.next();
        this.toastr.warning(this.translate.instant('SUBSCRIPTION_DELETED'), this.translate.instant('SUCCESS'));
        this.showSpinnerDelete = false;
      },
      error => {
        this.showSpinnerDelete = false;
      });
  }

  openExportCsvInterface(project) {
    this.projectMeasureService.openExportCsvInterface(project);
  }

  getIconStatus(status: number, isMath: boolean = false) {
    let icon = this.iconService.faSmile;
    if (status === 0) {
      icon = this.iconService.faSadTear;
    }
    if (isMath) {
      if (status === 2) {
        icon = this.iconService.faFrown;
      } else if (status === 3) {
        icon = this.iconService.faSpinner;
      }
    }
    return icon;
  }

  private getProjects() {
    this.setMatTable(this.projectsService.getProjectsForSubscription(this.activeProject), this.displayedColumns);
  }

}
